/**
 * SERP - Search Engine Results Page
 *
 * @packageDocumentation
 */
import '@total-typescript/ts-reset';

import initApplication from '~/initApplication';
import { handleInitError } from './handleInitError';

(async () => {
    try {
        if (document.readyState === 'interactive' || document.readyState === 'complete') {
            await initApplication();
        } else {
            document.addEventListener('DOMContentLoaded', async () => {
                await initApplication();
            });
        }
    } catch (error) {
        handleInitError({ error });
    }
})();
